import React from "react";

var EnergyCircleIcon = function EnergyCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zM9.764 19.842a.665.665 0 0 1-1.074-.684L10.46 13H4l10.236-8.842a.666.666 0 0 1 1.074.685L13.54 11H20z"
  }));
};

EnergyCircleIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
EnergyCircleIcon.defaultProps.solid = true;
export default EnergyCircleIcon;